import { DashboardPassportTable } from "./DashboardPassportTable";

export default DashboardPassportTable;
